// extracted by mini-css-extract-plugin
module.exports = {"grad":"SoLieuBieuDomobile_grad__2OTc6"};